import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { getLanguage } from 'Utility/globalMethods'

export const HelmetWrapper = ({ children }) => <Helmet htmlAttributes={{ lang: getLanguage() }}>{children}</Helmet>

HelmetWrapper.propTypes = {
  /** This prop is a node. It represents the children that will be displayed on the header menu. */
  children: PropTypes.node
}

HelmetWrapper.defaultProps = {
  // Add here some default propTypes values
  children: null
}
